const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const iconWidth = 35;
  const iconRatioForWhiteBorder = 0.65;
  const iconRatioForBlackBorder = 0.75;

  return {
    playerIconContainer: props => ({
      position: 'relative',
      display: 'inline-block',
      width: props.iconWidthPx || iconWidth,
      height: props.iconWidthPx || iconWidth,
    }),
    playerAvatar: props => {
      const {isBlackBorder} = props;

      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: `${(isBlackBorder ? iconRatioForBlackBorder : iconRatioForWhiteBorder) * 100}%`,
        height: `${(isBlackBorder ? iconRatioForBlackBorder : iconRatioForWhiteBorder) * 100}%`,
        transform: 'translate(-50%, -50%)',
        '& img': {
          borderRadius: '50%',
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          verticalAlign: 'top',
        },
      };
    },
    playerAvatarBorder: props => ({
      fontSize: props.iconWidthPx || iconWidth,
      '& image': {
        height: '100%',
        width: '100%',
      },
    }),
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
